<template>
      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil"   :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
        
  <v-expand-transition>
        <div v-if="Hide">
  <NewProtokoll :schoolId="schoolId" :id="id"  v-model="dialogClass"   :membernameandId="membernameandId" />
          <div v-if="Protokoll.length!=0">
  <NewProtokoll :schoolId="schoolId" :id="id"  v-model="dialog" :Oldclass="Class"  :membernameandId="membernameandId" />
  <div>
    <v-flex justify="center">
            <RemoveWindow   Type="protokoll" :removeItem="removeItem" v-model="dialogDelete"   Headline="Ta bort protokollet " WarningText="Är du säker på att du vill ta bort detta protokoll från EHTKollen? Ett protokoll som är
              borttagen går inte att återfå utan måste länkas om på nytt. Dokumentet är dock kvar på filservern där länken är tagen ifrån."    />

    </v-flex>
                <v-text-field
          v-model="search"
          label="Sök efter protokoll"
          class="mx-4"
        ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="Protokoll"
      item-key="name"
      sort-by="name"
      class="elevation-1"
      :pagination.sync="pagination"
      :search="search"
      show-group-by
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.description }}</td>
        <td class="text-xs-right">
                    <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="openLink(props.item)"
            color="purple ligthen-1"
          >
            <v-icon dark> wysiwyg </v-icon>
          </v-btn>
          </td>
       
       

         <td class="text-xs-right">
          {{  props.item.hasOwnProperty('createDate') ?    locfun.getDate(
              props.item.createDate
            ): 'Ingen data att visa' }}
        </td>

 <td class="text-xs-right">
          {{
            locfun.getName(
              props.item.uploader,
              [],
              membernameandId
            )
          }}
        </td>
                 <td class="text-xs-right">

                   {{   props.item.hasOwnProperty('uploadDate') ?    locfun.getDate(
              props.item.uploadDate
            ) : 'Ingen data att visa' }}  
        </td>
                 <td class="text-xs-right">
         {{   props.item.hasOwnProperty('expireDate') ? locfun.getDate(
              props.item.expireDate
            )  : 'Länken är inte tidsbestämd' }}   
        </td>
         <td class="text-xs-right">
     {{   props.item.hasOwnProperty('reviewer') ?  locfun.getName(
              props.item.reviewer,
              [],
              membernameandId
            ) : 'Protokollet har ingen justerare' }} 
        </td>
        <td class="text-xs-right">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              Class=props.item;dialog = true;
            "
            color="green ligthen-1"
          >
            <v-icon dark> upgrade </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right">
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
         <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
                 <v-btn 
      class="mx-2"
      dark
      @click="dialogClass=true"
      color="green darken-1"
    >
      Lägg till ett protokoll
    </v-btn>
  </div>
        </div>
              <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-3 text-center'">  
    <span class="tt" color="white">Det finns inga protokoll ännu.</span>
                     <v-btn  
      class="mx-2"
      dark
      @click="dialogClass=true"
      color="green darken-1"
    >
      Lägg till ett protokoll
    </v-btn>
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
import NewProtokoll from "./NewProtokoll";
import RemoveWindow from "../assets/RemoveWindow";
export default {
  name: "Protokoll",
  components: {
    NewProtokoll,RemoveWindow
  },
  props: {
    // content: Array,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    id: String,
    
  },

  watch: {
  },
  created() {
    this.locfun = new fun();

  },
  computed: {
    ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters('classesAP', ['Protokoll','ProtokollsFetched']),
  },
  methods: {
    ...mapActions('classesAP', ['initProtokolls']),

    Loadin()
    {
    if (this.ProtokollsFetched==false) {
      //console.log("Fetched" + this.schoolId);   
         this.initProtokolls(this.schoolId)
}  
    },
    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },
IsOpen(AP,id)
{
  if (AP.hasOwnProperty('openedLink')) {
    

      let openedTime= AP.openedLink.find(teacher => teacher.id == id);
    if (openedTime==undefined) {
      return "Inte öppnad"
    }
    else
    return "Öppnat "+this.locfun.getDate(openedTime.time)
      }
        return "Inte öppnad"
},

openAccess(Case){
 let Class= this.classes.find(element => element.id == Case.class); 

  this.accessItem.items= [];
// if (Case.accessType=="mentor" ||Case.accessType=="all"  ||Case.accessType=="teacher"  ) {
if (Case.accessType!="spec") {
  Class.mentorIds.forEach(element => {
    
     this.accessItem.items.push({name:element, icon:"mentor", time:this.IsOpen(Case,element)})
  });
}
if (Case.accessType=="all" ||Case.accessType=="teacher") {
  Class.teacherIds.forEach(element => {
     this.accessItem.items.push({name:element, icon:"teacher", time:this.IsOpen(Case,element)})
  });
}
if (Case.accessType=="spec") {
  Case.specAccess.forEach(element => {
     this.accessItem.items.push({name:element
     , time:this.IsOpen(Case,element)})
  });
} 
// // (this.accessItem)
 this.accessItem.name = Case.name;
 this.dialogAccess = true;
},
openLink(item){
  if (this.role=="teacher") {
    if (!item.hasOwnProperty('openedLink')) {
      item.openedLink=[]
    }
   if(undefined==item.openedLink.find(element => element.id == this.id))
   {
    item.openedLink.push({id:this.id,time: Date.now()})
    this.saveAP(item);
   }

  }
          window.open(item.link, "_blank");  
},
    ...mapActions("classesAP", ["removeAP",'saveAP']),
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      
      search: '',
            pagination: {
          sortBy: 'steps[0].starttime'
        },
      removeItem: { name: "temp", id: "temp" },
      accessItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dialogAccess: false,
      dis: {},
      dialog: false,
      dialogClass: false,
      Class: null,
      Choosen: null,
      Hide: false,
      headers: [
        {
          text: "Titel",
          align: "start",
          value: "name"
        },
        { text: "Beskrivning", value: "description", align: "right" },
        { text: "Länk", value: "link", align: "right" },
        { text: "Skapad", value: "createDate", align: "right" },
        { text: "Uppladdare", value: "uploader", align: "right" },
        { text: "Uppladdat", value: "uploadDate", align: "right" },
        { text: "Utgår", value: "expireDate", align: "right" },
        { text: "Justerare", value: "reviewer", align: "right" },
        { text: "Ändra", value: "ändra", align: "right"  },
        { text: "Ta bort", value: "tabort", align: "right"},
      ],
    };
  },
};
</script>